export const packingPageStatusEnum = {
    NO_RELEASE: 'NO RELEASE',
    LOADING: 'LOADING',
    RELEASE_ERROR: 'RELEASE ERROR',
    RELEASE_SUCCESS: 'RELEASE SUCCESS',
};

// 1 minutes
export const TIME_BEFORE_SET_INACTIVE = 60_000